module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-01-en.93a826cffa76073c25de9d07f73e7de3.png";